module.exports = __webpack_public_path__ + "img/a04.9703ff65.jpg";